/*
 * @Description:
 * @Version: 2.0销售合同有关语言包
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  新增飞书合同: 'New Feishu contract',
  新建飞书合同: 'New Feishu contract',
  新增烽火合同: 'New Beacon contract',
  编辑烽火合同: 'Edit Beacon contract',
  基本信息: 'Basic information',
  添加报价单明细: 'Add quotation details',
  添加明细: 'Add details',
  编辑合同明细: 'Edit contract details',
  添加合同明细: 'Add contract details',
  请选择报价单: 'Please select a quotation!',
  提交成功: 'Submission success',
  合同明细: 'Contract details',
  资料沉淀: 'Data precipitation',
  审批中的销售合同不可作废: 'The sales contract that is under approval cannot be voided',
  一个合同只能选择相同币种的价格: 'A contract can only be priced in the same currency'
};
